(function() {
	'use strict';
	angular.module('app.setup')
		.controller('customerOrderStatusCategoryForm', customerOrderStatusCategoryForm);

	customerOrderStatusCategoryForm.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'customerOrderStatusCategoryService'];
	function customerOrderStatusCategoryForm($scope, $rootScope, $timeout, $filter, customerOrderStatusCategoryService) {
		var vm = this;
		// view model functions
		vm.customerOrderStatusCategory = null;
		vm.action = $scope.action;
		vm.close = close;
		vm.save = save;
		init();
		
		function init() {
			vm.customerOrderStatusCategory = {};
		}

		function save() {
			customerOrderStatusCategoryService.addCustomerOrderStatusCategory(vm.customerOrderStatusCategory).then(function(message) {
				$scope.result(message, message == 'Customer Order Status Category created successfully');
			});
		}

		function close() {
			$scope.result('', false);
		}
	}
})();
